export const getEntries = (labels) => {
    let entries = [];
    for (let i = 0; i < labels?.length; i++) {
        let entry = {};
        entry.label = labels[i]?.name;
        entry.key = labels[i]?.name;
        entry.value = labels[i]?.locale;
        entry.disabled = false;
        entry.selected = i === 0;
        entry.countryCode = entry.value === "at_DE" || entry.value === "ch_DE" ? entry.value.toUpperCase().split("_")[0] : entry.value.split("_")[1];
        entries.push(entry);
    }
    return entries;
};